import { render } from "./StartRequest.vue?vue&type=template&id=7f16e06a"
import script from "./StartRequest.vue?vue&type=script&lang=js"
export * from "./StartRequest.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\DimmyMarcelissen\\WebstormProjects\\divindenduitkering_toets\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__